import { prefix } from '@goldwasserexchange/react-topmodel';

export const checkboxListInputPrefixer = prefix('CheckboxList');
